import { Typography } from "@mui/material";

import { Box, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import GreetingHeader from "../../components/GreetingHeader";
import CustomButton from "../../components/CustomButton";
import Grid from "@mui/material/Unstable_Grid2";
import { saveAs } from "file-saver";

import { MenuItem } from "@mui/material";
import { IconButton, Menu } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/Attachment";

import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { getFromLocalStorage } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";
import SearchBarFilter from "../../components/SearchBarFilter";

import {
  selectedItems,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR,
  ERROR_FOUND_DURING_API_CALL,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  SOME_ERROR_OCCURRED,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import DebugLog, { printLog } from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  downloadFreezeAccountReports,
  downloadPdfViewerData,
  getAttachmentInfo,
  getFreezeAccountAuditActivityDetails,
  getFreezeAccountList,
  getFreezedAccountCount,
  unFreezeAccountDetails,
  updateFreezeAccountDetails,
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";

import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import UserActivityInfo from "../../components/UserActivity";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import AddEarmarkDialogInput from "../earmark/AddEarmarkDialog";
import EarmarkHighlightStats from "../../components/EarmarkHighlightedStats";
import FrozenAccountUpdateDialog from "./FrozenAccountUpdateDialog";
import AddFreezeAccountDialog from "./AddFreezeAccountDialog";
import { AuthContext } from "../../context/AuthContext";
import { isEmptyArray } from "formik";
import { DownloadFileWithDatePickerSelectionDialog } from "../../components/DownloadFileWithDatePickerSelectionDialog";
import PdfViewerDialog from "../exclusion/PdfViewerDialog";
import FileDialog from "../../components/FileDialog";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
    keyValue: "Account Name",
    displayName: "Name",
    paramName: "accountName",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  // {
  //   keyValue: 'Status',
  //   displayName: 'Status',
  //   paramName: 'status',
  //   isDateFilter: false,
  //   isSearchBarDropdown: false,
  //   searchBarDropdownOptions: [],
  // },
  {
    keyValue: "Account Code",
    displayName: "Code",
    paramName: "accountCode",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Vendor Code",
    displayName: "Vendor",
    paramName: "vendorCode",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Froze By",
    displayName: "Froze By",
    paramName: "frozeBy",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Freeze On Date",
    displayName: "Date",
    paramName: "freezeOn",
    isDateFilter: true,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: "Reason",
    displayName: "Reason",
    paramName: "reason",
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
];

export function FreezeAccountScreen() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [reset, setReset] = useState(0);
  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [openSaveAndRemoveDialog, setOpenSaveAndRemoveDialog] = useState(false);
  const [openAddFreezeAccountDialog, setOpenAddFreezeAccountDialog] =
    useState(false);

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
 
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalFreezedAccount, setTotalFreezedAccount] = useState("");

  const [allFreezeAccountDetails, setAllFreezeAccountDetails] = useState([]);
  const [freezeAccountAuditActivity, setFreezeAccountAuditActivity] = useState(
    []
  );

  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [addNewButtonVisible, setAddNewButton] = useState(false);
  const [editAllowed, setEditAllowed] = useState(false);

  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination for data grid
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(25);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);
  const [selectedDateRange, setSelectedDateRange] = useState(
    CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS
  );

  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(15);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");

  const [open, setOpen] = useState(false);

  // user context
  const { authDetails } = React.useContext(AuthContext);

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // sort model
  const [sortModel, setSortModel] = useState([]);
  let blob;
  let filename;
  let url;

  const [openFileDialog, setFileDialogOpen] = useState(false);
  const [files, setFiles] = useState([]);
  const [pdfData, setPdfData] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [commentData, setComment] = useState("");

  // sorting handling
  useEffect(() => {
    getFreezeAccountDetailsData(
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  useEffect(() => {
    updateButtonVisibility();

    getFreezeAccountDetailsData(paginationModel.page, paginationModel.pageSize);

    getFreezeAccountActivityDetails(activityCurrentPage, selectedDateRange);

    getFreezedAccountCountDetails();

    // downloadReports()
  }, []);

  useEffect(() => {
    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  const updateButtonVisibility = () => {
    try {
      if (authDetails.sessionId !== "") {
        const userDetails = authDetails.userAccessDetails.menuList;

        let adjustments = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Adjustment") {
                adjustments = [...item.menuItem];
              }
            });

            adjustments.forEach((itemA, index) => {
              if (itemA.menuName === "Freeze Account") {
                const actionButtonList = [...itemA.actionButton];

                actionButtonList.forEach((items, index) => {
                  if (items.buttonName === "DOWNLOAD") {
                    setDownlaodButton(true);
                  } else if (items.buttonName === "ADD NEW") {
                    setAddNewButton(true);
                  } else if (items.buttonName === "EDIT") {
                    setEditAllowed(true);
                  }
                });
              }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  };

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 56; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= paginationModel.pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }
    const totalHeight = headerHeight + (rowCount + 1) * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
        navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }
  function downloadFreezeAccountReport(fileType, startDate, endDate) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          fromDate: startDate,
          toDate: endDate,
          // accountCode: params.code,
          // accountName: params.name,
          // reason: params.reason,

          reportTemplate: "FREEZE_ACCOUNT_REPORT",
          reportFormat: fileType,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.FREEZE_ACCOUNT_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadFreezeAccountReports(requestData)
            .then((response) => {
              setLoading(false);

              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                // setJsonData(jsonObject);
                printLog("JSON data:", JSON.stringify(jsonObject));

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    showErrorAlert(ERROR, jsonObject.displayErrorMessage);
                  } else {
                    showErrorAlert(ERROR, jsonObject.errorDescription);
                  }
                }
              } else {
                let blob;
                const currentDate = new Date();
                const day = String(currentDate.getDate()).padStart(2, "0");
                const month = String(currentDate.getMonth() + 1).padStart(
                  2,
                  "0"
                );
                const year = String(currentDate.getFullYear());

                // let filename be "EarmarkReport_YYYY-MM-DD"
                let filename = `FreezeAccountReport_${year}-${month}-${day}`;
                switch (fileType) {
                  case "CSV":
                    blob = new Blob([response.data], { type: "text/csv" });
                    filename = filename + ".csv";
                    break;
                  case "XLS":
                    blob = new Blob([response.data], {
                      type: "application/vnd.ms-excel",
                    });
                    filename = filename + ".xls";
                    break;
                  case "PDF":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = filename + ".pdf";
                    break;

                  default:
                    throw new Error("Invalid file type");
                }

                // Use FileSaver to save the file
                saveAs(blob, filename);
              }
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 100; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (totalNoOfRows <= pageSize) {
      rowCount = totalNoOfRows; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });
    getFreezeAccountDetailsData(
      0,
      paginationModel.pageSize,
      filterParam,
      searchQuery
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    getFreezeAccountDetailsData(0, newPageSize);
  };

  const handleClose = () => {
    setOpen(false);
    setFileDialogOpen(false);
  };

  // const handlePageJump = (event) => {
  //   setCurrentPage(parseInt(event.target.value, 10) - 1);
  // };

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    // Avoid using state directly for API call as the state update function is async.
    // Means it will not update the state immediately and it will be using the old state value.
    getFreezeAccountDetailsData(newPage, paginationModel.pageSize);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    getFreezeAccountDetailsData(newPage, paginationModel.pageSize);
  };

  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getFreezeAccountActivityDetails(newPage, selectedDateRange);
  };

  function freezeUnfreezeAddDealer() {
    navigate(CONSTANT.UNFREEZE_FREEZE_DEALER_ROUTE);
    // setOpen(true);
  }

  const handleRowClick = (params) => {
    if (params.field !== "actions") {
      if (editAllowed) {
        if (params.row.isEditAble === "true") {
          setSelectedItem(params.row);
          setOpenSaveAndRemoveDialog(true);
        } else {
          showErrorAlert(ALERT, "EDIT / UPDATE is not allowed!");
        }
      }
    }
  };

  function getAttachmentDetails(referenceId) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          attachmentType: "FREEZE_ACCOUNTS",
          reference: referenceId,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_ATTACHMENT_INFO
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
          };

          getAttachmentInfo(requestData)
            .then((response) => {
              if (response.data.result.attachments !== null) {
                setFiles(response.data.result.attachments);
                setFileDialogOpen(true);
              } else {
                showErrorAlert(ALERT, "No Attachment Found!");
              }

              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              if (
                error !== null &&
                error !== undefined &&
                error.data !== null &&
                error.data !== undefined &&
                error.data.errorCode != null &&
                error.data.errorCode !== undefined &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  const freezedAccountDetailsColumnHeader = [
    {
      field: "id",
      filterable: false,
      headerName: "ID",
      flex: 0.5,
      hide: true,
      headerAlign: "left",
    },
    {
      field: "isEditAble",
      filterable: false,
      headerName: "isEditAble",
      flex: 0.5,
      hide: true,
      headerAlign: "left",
    },

    {
      field: "companyName",
      headerName: "NAME",
      flex: 1.5,
      cellClassName: "bold-column--cell",
      headerAlign: "left",
    },
    {
      field: "status",
      flex: 1,
      headerName: "STATUS",
      headerAlign: "left",
      headerClassName: (params) =>
        params.field === "payOutDate" ? "bold-header-style" : null,
      cellClassName: "name-column--cell",
    },
    {
      field: "companyCode",
      headerName: "CODE",
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "vendorCode",
      headerName: "VENDOR",
      flex: 1,
      headerAlign: "left",
    },

    {
      field: "freezeBy",
      headerName: "FROZE BY",
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "freezeOn",
      headerName: "DATE",
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "freezeReason",
      headerName: "REASON",
      flex: 1,
      headerAlign: "left",
      cellClassName: "bold-column--cell",
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <MoreOptionsButton row={params.row.companyCode} />
      ),
    },
  ];

  const MoreOptionsButton = ({ row }) => {
    const companyCode = row.companyCode;
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleOptionClick = (option, event) => {
      event.stopPropagation();
      DebugLog(`Option ${option} clicked` + JSON.stringify(row));
      getAttachmentDetails(row);
      handleClose();
    };

    return (
      <>
        <IconButton onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={(event) => event.stopPropagation()} // Prevent row click even inside the menu
        >
          <MenuItem onClick={(event) => handleOptionClick("Download", event)}>
            Get Attachments Details
          </MenuItem>
          {/* <MenuItem onClick={(event) => handleOptionClick("View", event)}>
            View Attachment
          </MenuItem> */}
        </Menu>
      </>
    );
  };

  const handleCloseSaveAndUnfreezeEarmarkDialog = () => {
    setOpenSaveAndRemoveDialog(false);
    setOpenAddFreezeAccountDialog(false);
    DebugLog("Dialog Closed");
  };
  function requestCancelDialog(params, updatedValue) {
    setOpenSaveAndRemoveDialog(false);
    setOpenAddFreezeAccountDialog(false);
  }
  function getFreezedAccountCountDetails() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          //pageNumber: 0,
          //  pageSize: 100,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_FREEZED_ACCOUNT_COUNT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
          };

          getFreezedAccountCount(requestData)
            .then((response) => {
              setTotalFreezedAccount(response.data.result.totalFrozen);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate(CONSTANT.LOGIN);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }
  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getFreezeAccountActivityDetails(activityCurrentPage, selectedDateRange);
  };

  function getFreezeAccountActivityDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        switch (passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          fromDate: fromDate.toISOString(),
          toDate: toDate.toISOString(),
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_FREEZE_ACCOUNT_ACTIVITY_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getFreezeAccountAuditActivityDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.freezeAccountAuditDetails.content.map(
                  (row) => ({
                    ...row,
                    id: generateRandomId(),
                  })
                );
              setFreezeAccountAuditActivity(contentData);
              setActivityTotalNoOfPages(
                response.data.result.freezeAccountAuditDetails.totalPages
              );
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function getFreezeAccountDetailsData(
    pageNumber,
    pageSize,
    filterParam,
    searchQuery
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
          pageNumber,
          pageSize,
          filterParam,
          searchQuery
        );

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_FREEZE_ACCOUNT_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getFreezeAccountList(requestData)
            .then((response) => {
              const contentData = response.data.result.content.map((row) => ({
                ...row,
                id: generateRandomId(),
              }));
              setAllFreezeAccountDetails(contentData);

              setRowsPerPage(response.data.result.content.length);
              setTotalNoOfRows(response.data.result.totalElements);
              setTotalNoOfPages(response.data.result.totalPages);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate(CONSTANT.LOGIN);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  // Create Request Object for getEarMarkDetails API
  function createRequestObject(
    pageNumber,
    pageSize,
    selectedFilter,
    filterValue
  ) {
    // Initialize all fields to null
    let requestObject = {
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    // Set the appropriate field based on filterCriteria
    if (
      selectedFilter != null &&
      selectedFilter != undefined &&
      selectedFilter != ""
    ) {
      if (
        filterValue != null &&
        filterValue != undefined &&
        filterValue != ""
      ) {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
    try {
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "companyName":
            requestObject.sortProperty = "COMPANY_NAME";
            break;
          case "status":
            requestObject.sortProperty = "FR_STATUS";
            break;
          case "companyCode":
            requestObject.sortProperty = "COMPANY_CODE";
            break;
          case "vendorCode":
            requestObject.sortProperty = "VENDOR";
            break;
          case "freezeBy":
            requestObject.sortProperty = "FR_FROZE_BY";
            break;
          case "freezeOn":
            requestObject.sortProperty = "FR_FROZE_ON";
            break;
          case "freezeReason":
            requestObject.sortProperty = "FR_REASON";
            break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      }
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  async function requestUpdateFreezeAccountDetailsData(
    params,
    updatedValue,
    selectedFile
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        let requestObject;
        let base64Content = "";

        if (selectedFile) {
          const fileNameWithoutExtension = selectedFile.name
            .split(".")
            .slice(0, -1)
            .join(".");

          const fileBase64Encoding = await getBase64(selectedFile);
          // Extract only the Base64 data
          base64Content = fileBase64Encoding.split(",")[1];
          //const fileByteArray = await getByteArray(selectedFile);
          requestObject = {
            fileName: fileNameWithoutExtension,
            fileType: selectedFile.type,
            accountCode: updatedValue.code,
            actionStatus: "",
            freezeReason: updatedValue.frozenReason,
          };
        } else {
          requestObject = {
            accountCode: updatedValue.code,
            actionStatus: "",
            freezeReason: updatedValue.frozenReason,
          };
        }

        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true);

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EARMARKS_DETAILS
        ).then((encryptedContentData) => {
          let requestData;

          if (base64Content !== null && base64Content !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: base64Content,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              loginUserName: getFromLocalStorage(USER_NAME),
              contentData: encryptedContentData,
            };
          }

          updateFreezeAccountDetails(requestData)
            .then((response) => {
              setLoading(false);
              showErrorAlert(
                "UPDATED",
                "Freeze account details updated successfully."
              );
              getFreezeAccountDetailsData(
                paginationModel.page,
                paginationModel.pageSize
              );
              getFreezeAccountActivityDetails(
                activityCurrentPage,
                selectedDateRange
              );

              getFreezedAccountCountDetails();
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function openUnfreezeAccountDialog(params, updatedValue) {
    setSelectedItem(params.row);
    setOpenAddFreezeAccountDialog(true);
  }

  async function requestUnFreezeAccountDetailsData(
    params,
    updatedValue,
    selectedFile
  ) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true);

        let requestObject;
        let base64Content = "";

        if (selectedFile) {
          const fileNameWithoutExtension = selectedFile.name
            .split(".")
            .slice(0, -1)
            .join(".");

          const fileBase64Encoding = await getBase64(selectedFile);
          // Extract only the Base64 data
          base64Content = fileBase64Encoding.split(",")[1];
          //const fileByteArray = await getByteArray(selectedFile);
          requestObject = {
            fileName: fileNameWithoutExtension,
            fileType: selectedFile.type,
            accountCode: updatedValue.code,
            actionStatus: "1",
            unFreezeReason: updatedValue.frozenReason,
          };
        } else {
          requestObject = {
            accountCode: updatedValue.code,
            actionStatus: "1",
            unFreezeReason: updatedValue.frozenReason,
          };
        }

        // const requestObject = {
        //   accountCode: updatedValue.code,
        //   actionStatus: "1",
        //   unFreezeReason: updatedValue.frozenReason,
        // };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_EARMARKS_DETAILS
        ).then((encryptedContentData) => {
          let requestData;

          if (base64Content !== null && base64Content !== "") {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              loginUserName: getFromLocalStorage(USER_NAME),
              contentData: encryptedContentData,
              fileContent: base64Content,
            };
          } else {
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              loginUserName: getFromLocalStorage(USER_NAME),
              contentData: encryptedContentData,
            };
          }

          // const requestData = {
          //   requestId: generateRequestId(),
          //   loginId: getFromLocalStorage(LOGIN_ID),
          //   sessionId: getFromLocalStorage(SESSION_ID),
          //   loginUserName: getFromLocalStorage(USER_NAME),
          //   contentData: encryptedContentData,
          // };

          unFreezeAccountDetails(requestData)
            .then((response) => {
              setLoading(false);
              showErrorAlert("UNFREEZED", "Account un-freezed successfully.");
              getFreezeAccountDetailsData(
                paginationModel.page,
                paginationModel.pageSize
              );
              getFreezeAccountActivityDetails(
                activityCurrentPage,
                selectedDateRange
              );

              getFreezedAccountCountDetails();
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : SOME_ERROR_OCCURRED;

                if (message)
                  showErrorAlert(
                    ERROR,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  const openDownloadOptionsDialog = (type) => {
    let title = "";
    if (type === "Download") {
      title = "Download";
    }
    setReset(0);
    setClickedButtonType(type);
    setDialogTitle(title);
    setDownloadFileDialogOpen(true);
  };

  const handleFileDownloadDialogClose = () => {
    setReset(1);
    setDownloadFileDialogOpen(false);
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
    setReset(1);

    if (type === "Cancel") {
      startDate = null;
      endDate = null;
    } else {
      downloadFreezeAccountReport(fileType, startDate, endDate);
    }
    setReset(0);
  };
  const downloadPreviedFile = () => {};
  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }
  const openAttachment = (referenceId, attachmentType) => {
    let requestData;
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(PROCESSING_PLEASE_WAIT);
        setLoading(true); // Hide the progress dialog

        if (
          attachmentType !== null &&
          attachmentType !== undefined &&
          attachmentType !== ""
        ) {
          requestData = {
            attachmentType: attachmentType,
            referenceId: referenceId,
          };
        } else {
          requestData = {
            attachmentType: "FREEZE_ACCOUNTS",
            referenceId: referenceId,
          };
        }

        initializeEncryption(
          requestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EXCLUSION_FILE_READ
        ).then((encryptedContentData) => {
          const addExclusionRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
            loginUserName: getFromLocalStorage(USER_NAME),
          };

          downloadPdfViewerData(addExclusionRequestData)
            .then((response) => {
              // Determine the content type from the headers
              const contentType = response.headers["content-type"];
              const mimeType = contentType.split(";")[0];
              const type = contentType.split("/")[1];

              // Handle different content types
              if (mimeType.includes("application/json")) {
                const arrayBuffer = response.data;

                // Function to convert ArrayBuffer to JSON
                const arrayBufferToJson = (buffer) => {
                  const decoder = new TextDecoder("utf-8");
                  const jsonString = decoder.decode(buffer);
                  return JSON.parse(jsonString);
                };

                // Convert the ArrayBuffer to JSON and set it in state
                const jsonObject = arrayBufferToJson(arrayBuffer);

                if (jsonObject !== null && jsonObject.responseCode === "-1") {
                  if (
                    jsonObject.displayErrorMessage !== null &&
                    jsonObject.displayErrorMessage !== ""
                  ) {
                    showErrorAlert(ERROR, jsonObject.displayErrorMessage);
                  } else {
                    showErrorAlert(ERROR, jsonObject.errorDescription);
                  }
                }
              } else {
                let fileBlob;
                switch (mimeType) {
                  case "image/png":
                    blob = new Blob([response.data], { type: "image/png" });
                    filename = referenceId + ".png";

                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/png" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpeg":
                    blob = new Blob([response.data], { type: "image/jpeg" });
                    filename = referenceId + ".jpeg";

                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);

                    // fileBlob = new Blob([blob], { type: "image/jpeg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "image/jpg":
                    blob = new Blob([response.data], { type: "image/jpg" });
                    filename = referenceId + ".jpg";
                    url = URL.createObjectURL(blob);
                    setPdfData(null);
                    setImageUrl(url);
                    setOpen(true);
                    // fileBlob = new Blob([blob], { type: "image/jpg" });
                    // FileSaver.saveAs(fileBlob, filename);
                    break;

                  case "application/pdf":
                    blob = new Blob([response.data], {
                      type: "application/pdf",
                    });
                    filename = referenceId + ".pdf";
                    url = URL.createObjectURL(blob);
                    setImageUrl(null);
                    setPdfData(url);
                    setOpen(true);
                    break;

                  default:
                    break;
                }

                if (
                  mimeType !== "application/pdf" &&
                  mimeType !== "image/jpg" &&
                  mimeType !== "image/jpeg" &&
                  mimeType !== "image/png"
                ) {
                  showErrorAlert(ALERT, "File type is not supported!");
                }
              }
              setLoading(false);
            })
            .catch((error) => {
              setLoading(false);
              if (
                error !== null &&
                error !== undefined &&
                error.data !== null &&
                error.data !== undefined &&
                error.data.errorCode != null &&
                error.data.errorCode !== undefined &&
                error.data.errorCode === ApiErrorCode.SESSION_EXPIRED
              ) {
                navigate(CONSTANT.LOGIN);
              } else if (
                error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
              ) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_FOUND_DURING_API_CALL + JSON.stringify(message)
      );
    }
  };
  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <AddEarmarkDialogInput open={open} onClose={handleClose} />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        <FileDialog
          open={openFileDialog}
          onClose={handleClose}
          files={files}
          previewFile={openAttachment}
        />

        <PdfViewerDialog
          open={open}
          handleClose={handleClose}
          downloadPdf={downloadPreviedFile}
          pdfUrl={pdfData}
          imageUrl={imageUrl}
          comment={commentData}
        ></PdfViewerDialog>
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container>
            <Grid item>
              <GreetingHeader name={"Freeze Accounts"}></GreetingHeader>
            </Grid>

            <Box position="absolute" right={25} top={60}>
              <SearchBarFilter
                filterProps={filterProps}
                onSearch={handleSearch}
              ></SearchBarFilter>
            </Box>
          </Grid>
          {/* Greetings Header */}

          {/* Highlight Stats */}
          <EarmarkHighlightStats
            highlight0={"Total Frozen"}
            highlightTotal={totalFreezedAccount}
            highlight1={""}
            highlight1Stat={""}
            highlight2={""}
            highlight2Stat={""}
            highlight3={""}
            highlight3Stat={""}
          ></EarmarkHighlightStats>
          {/* Highlight Stats */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            {/* <SectionHeader
              sectionIcon={"../../assets/common/onhold.svg"}
              sectionHeading={"On Hold"}
            ></SectionHeader> */}

            {allFreezeAccountDetails.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  // rows={filteredRows.slice(
                  //   currentPage * pageSize,
                  //   (currentPage + 1) * pageSize
                  // )}
                  rows={allFreezeAccountDetails}
                  columns={freezedAccountDetailsColumnHeader}
                  checkboxSelection={false}
                  selecion
                  pageSize={pageSize}
                  pageSizeOptions={[25, 50, 100]}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  //onRowClick={handleRowClick}
                  onCellClick={handleRowClick}
                  autoHeight
                  sortModel={sortModel}
                  onSortModelChange={(model) => setSortModel(model)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {allFreezeAccountDetails.length > 0 ? (
            <Box mt={1}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/*  Section */}

          <FrozenAccountUpdateDialog
            open={openSaveAndRemoveDialog}
            onClose={handleCloseSaveAndUnfreezeEarmarkDialog}
            onDialogButtonClick={requestUpdateFreezeAccountDetailsData}
            onDialogRemoveButtonClick={openUnfreezeAccountDialog}
            data={selectedItem}
          />

          <AddFreezeAccountDialog
            open={openAddFreezeAccountDialog}
            onClose={handleCloseSaveAndUnfreezeEarmarkDialog}
            onDialogButtonClick={requestUnFreezeAccountDetailsData}
            onDialogRemoveButtonClick={requestCancelDialog}
            data={selectedItem}
            screenType={0}
          />

          {/* Action Buttons */}

          {allFreezeAccountDetails.length > 0 ? (
            <Grid item mt={1} justifyContent={"flex-start"} pb={5}>
              <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
                {addNewButtonVisible ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnTxt={"ADD NEW"}
                    onClick={freezeUnfreezeAddDealer}
                  ></CustomButton>
                ) : (
                  ""
                )}
                {/* {downloadButtonVisible ? (
                  <DownloadDropdownButton
                    onFileTypeSelected={downloadFreezeAccountReport}
                  />
                ) : (
                  ""
                )} */}
                {downloadButtonVisible ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Download.svg" width={22} />
                    }
                    btnTxt={"Download"}
                    onClick={() => openDownloadOptionsDialog("Download")}
                  ></CustomButton>
                ) : (
                  ""
                )}
              </Stack>
            </Grid>
          ) : (
            ""
          )}
          {/* Action Buttons */}

          {/* activity list */}
          <Grid container>
            <UserActivityInfo
              type={"FreezeModule"}
              data={freezeAccountAuditActivity}
              ondateRangeChange={handleDateRangeChange}
              totalNoOfPages={activityTotalNoOfPages}
              onPageChange={handleActivityPageChange}
            />
          </Grid>
          {/* activity list */}

          {/* Confirmation Dialog */}
          <DownloadFileWithDatePickerSelectionDialog
            open={downloadFileDialogOpen}
            handleClose={handleFileDownloadDialogClose}
            handleSubmit={handleFileDownloadSubmit}
            type={clickedButtonType}
            title={dialogTitle}
            resetIndex={reset}
          />
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
